import { render, staticRenderFns } from "./NotificationAdd.vue?vue&type=template&id=0f43d0c6&scoped=true&"
import script from "./NotificationAdd.vue?vue&type=script&lang=js&"
export * from "./NotificationAdd.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAdd.vue?vue&type=style&index=0&id=0f43d0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f43d0c6",
  null
  
)

export default component.exports